(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["air-demand-vehicle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('air-demand-vehicle-picker')) {
  customElements.define('air-demand-vehicle-picker', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.section = this.closest('.shopify-section');
        this.native = this.parentElement.querySelector('variant-picker');
        if (!this.native) return;
        this.rows = JSON.parse(this.querySelector('[data-fitments]').textContent);
        this.year = this.querySelector('[data-year]');
        this.make = this.querySelector('[data-make]');
        this.model = this.querySelector('[data-model]');
        this.status = this.querySelector('[data-status]');
        this.makePlaceholder = this.make.options[0].textContent;
        this.ranges = new Map(this.rows.map(row => [row[0], this.yearRange(row)]));
        const years = new Set();
        this.ranges.forEach(range => { if (range) for (let year = range[0]; year <= range[1]; year += 1) years.add(year); });
        [...years].sort((a, b) => b - a).forEach(year => this.year.add(new Option(String(year), String(year))));
        this.year.value = this.dataset.yearSelected || '';
        this.ready = Boolean(this.dataset.selected && this.year.value);
        this.section.classList.toggle('air-demand-fitment-pending', !this.ready);
        this.populateMakes();
        const deepLinkId = new URLSearchParams(location.search).get('variant');
        const linked = this.rows.find(row => row[0] === this.dataset.selected && (this.dataset.yearSelected || row[0] === deepLinkId));
        const selected = linked && this.matchesYear(linked) ? linked : null;
        if (selected) {
          this.make.value = selected[1];
          this.populate(selected[0]);
          this.querySelector('[data-stock]').hidden = false;
          this.querySelector('[data-application]').textContent = selected[2];
          this.querySelector('[data-application]').hidden = false;
        }
        if (!selected) {
          this.clearSelection();
          if (linked && !this.year.value) {
            this.pendingLink = linked;
            this.make.add(new Option(linked[1], linked[1]));
            this.make.value = linked[1];
            this.model.add(new Option(linked[2].split('|')[0].trim(), linked[0]));
            this.model.value = linked[0];
            this.status.textContent = this.dataset.confirmYear;
          }
        }
        const options = { signal: this.lifecycle.signal };
        this.year.addEventListener('change', () => {
          this.request?.abort();
          const linked = this.pendingLink;
          this.pendingLink = null;
          this.clearSelection();
          this.populateMakes();
          if (linked && this.matchesYear(linked)) {
            this.make.value = linked[1];
            this.populate(linked[0]);
            this.choose();
          } else {
            this.populate();
          }
        }, options);
        this.make.addEventListener('change', () => {
          this.request?.abort();
          this.clearSelection();
          this.populate();
        }, options);
        this.model.addEventListener('change', () => this.choose(), options);
        this.section.addEventListener('submit', event => {
          if (!event.target.matches('.js-product-form')) return;
          const row = this.rows.find(item => item[0] === this.model.value && item[1] === this.make.value && this.matchesYear(item));
          if (!this.ready || !row) {
            event.preventDefault();
            event.stopImmediatePropagation();
            (!this.year.value ? this.year : !this.make.value ? this.make : this.model).focus();
          } else {
            const input = event.target.querySelector('input[name="id"]');
            input.value = row[0];
            let yearInput = event.target.querySelector('input[name="properties[Vehicle year]"]');
            if (!yearInput) {
              yearInput = document.createElement('input');
              yearInput.type = 'hidden';
              yearInput.name = 'properties[Vehicle year]';
              event.target.append(yearInput);
            }
            yearInput.value = this.year.value;
          }
        }, { capture: true, signal: this.lifecycle.signal });
        this.native.closest('.air-demand-native-picker').hidden = true;
        this.hidden = false;
      });
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.request?.abort();
    }
    yearRange(row) {
      return row[4];
    }
    matchesYear(row) {
      const range = this.ranges.get(row[0]);
      return Boolean(this.year.value && range && Number(this.year.value) >= range[0] && Number(this.year.value) <= range[1]);
    }
    populateMakes() {
      this.make.replaceChildren(new Option(this.makePlaceholder, ''));
      [...new Set(this.rows.filter(row => this.matchesYear(row)).map(row => row[1]))].sort().forEach(make => this.make.add(new Option(make, make)));
      this.make.disabled = !this.year.value;
    }
    populate(selected = '') {
      const rows = this.rows.filter(row => this.matchesYear(row) && row[1] === this.make.value);
      this.model.replaceChildren(new Option(this.dataset.placeholder, ''));
      rows.forEach(row => {
        const name = row[2].split('|')[0].trim();
        const duplicate = rows.some(other => other[0] !== row[0] && other[2].split('|')[0].trim() === name);
        this.model.add(new Option(duplicate ? `${name} · ${row[2].split('|').at(-1).trim()}` : name, row[0]));
      });
      this.model.value = selected;
      this.model.disabled = !this.make.value || rows.length === 0;
      this.status.textContent = this.make.value && !rows.length ? this.dataset.empty : '';
    }
    clearSelection() {
      this.ready = false;
      this.section.classList.add('air-demand-fitment-pending');
      this.querySelector('[data-stock]').hidden = true;
      this.querySelector('[data-application]').hidden = true;
      this.native.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
      this.native.updateVariantContent();
    }
    async choose() {
      this.request?.abort();
      const row = this.rows.find(item => item[0] === this.model.value && item[1] === this.make.value && this.matchesYear(item));
      this.clearSelection();
      if (!row) return;
      const selectors = [...this.native.optionSelectors];
      for (let i = 0; i < 2; i += 1) {
        const input = [...selectors[i].querySelectorAll('input')].find(item => item.value === row[i + 1]);
        if (!input) { this.status.textContent = this.dataset.error; return; }
        input.checked = true;
      }
      this.status.textContent = this.dataset.loading;
      this.request = new AbortController();
      const url = this.native.constructVariantUrl(null, this.native.getSelectedOptionIds(), row[0]);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Unable to load kit');
        const sections = await response.json();
        if (!this.isConnected) return;
        const html = new DOMParser().parseFromString(sections[this.native.dataset.sectionId], 'text/html');
        const newSection = html.getElementById(this.section.id);
        const variant = JSON.parse(newSection.querySelector('variant-picker [type="application/json"]').textContent);
        if (String(variant.id) !== row[0]) throw new Error('Fitment mismatch');
        const section = this.section;
        const native = this.native;
        newSection.querySelector('air-demand-vehicle-picker').dataset.yearSelected = this.year.value;
        native.updateContent(section, newSection, false);
        section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = row[0]; input.setAttribute('value', row[0]); });
        setTimeout(() => {
          const picker = section.querySelector('variant-picker');
          picker.announceChange();
          section.querySelector('air-demand-vehicle-picker [data-model]')?.focus();
        }, 30);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.clearSelection();
          this.status.textContent = this.dataset.error;
          this.model.value = '';
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["air-lift-vehicle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('air-lift-vehicle-picker')) {
  customElements.define('air-lift-vehicle-picker', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.section = this.closest('.shopify-section');
        this.native = this.parentElement.querySelector('variant-picker');
        if (!this.native) return;
        this.data = JSON.parse(this.querySelector('[data-fitments]').textContent);
        ['year','make','model','kit'].forEach(key => { this[key] = this.querySelector(`[data-${key}]`); });
        this.status = this.querySelector('[data-status]');
        this.fill(this.year, [...new Set(this.data.fitments.map(r => r[0]))].sort((a,b) => b-a));
        this.year.value = this.dataset.yearSelected || '';
        this.populateMakes();
        this.make.value = this.dataset.makeSelected || '';
        this.populateModels();
        this.model.value = this.dataset.modelSelected || '';
        this.populateKits();
        this.kit.value = this.dataset.yearSelected ? this.dataset.selected : '';
        this.ready = Boolean(this.currentRow() && this.kit.value);
        if (!this.ready) this.clear();
        else this.querySelector('[data-application]').textContent = `${this.year.value} ${this.make.value} ${this.model.value} · ${this.kit.selectedOptions[0].textContent}`;
        this.section.classList.toggle('air-lift-fitment-pending', !this.ready);
        const options = { signal: this.lifecycle.signal };
        this.year.addEventListener('change', () => { this.clear(); this.populateMakes(); this.populateModels(); this.populateKits(); }, options);
        this.make.addEventListener('change', () => { this.clear(); this.populateModels(); this.populateKits(); }, options);
        this.model.addEventListener('change', () => { this.clear(); this.populateKits(); }, options);
        this.kit.addEventListener('change', () => this.choose(), options);
        this.section.addEventListener('submit', event => {
          if (!event.target.matches('.js-product-form')) return;
          const row = this.currentRow();
          if (!this.ready || !row || !row[3].includes(this.kit.value)) {
            event.preventDefault(); event.stopImmediatePropagation();
            (!this.year.value ? this.year : !this.make.value ? this.make : !this.model.value ? this.model : this.kit).focus();
            return;
          }
          event.target.querySelector('input[name="id"]').value = this.kit.value;
          const props = { 'Vehicle year': this.year.value, 'Vehicle make': this.make.value, 'Vehicle model': this.model.value };
          Object.entries(props).forEach(([name,value]) => {
            let input = event.target.querySelector(`input[name="properties[${name}]"]`);
            if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; event.target.append(input); }
            input.value = value;
          });
        }, { capture: true, signal: this.lifecycle.signal });
        this.native.closest('.air-lift-native-picker').hidden = true;
        this.hidden = false;
      });
    }
    disconnectedCallback() { this.lifecycle?.abort(); this.request?.abort(); }
    fill(select, values) {
      select.replaceChildren(new Option(this.dataset.placeholder, ''));
      values.forEach(value => select.add(new Option(String(value), String(value))));
    }
    currentRow() { return this.data.fitments.find(r => r[0] === Number(this.year.value) && r[1] === this.make.value && r[2] === this.model.value); }
    populateMakes() {
      this.fill(this.make, [...new Set(this.data.fitments.filter(r => r[0] === Number(this.year.value)).map(r => r[1]))].sort());
      this.make.disabled = !this.year.value;
    }
    populateModels() {
      this.fill(this.model, [...new Set(this.data.fitments.filter(r => r[0] === Number(this.year.value) && r[1] === this.make.value).map(r => r[2]))].sort());
      this.model.disabled = !this.make.value;
    }
    populateKits() {
      this.fill(this.kit, []);
      const row = this.currentRow();
      if (row) row[3].forEach(id => this.kit.add(new Option(this.data.kits[id], id)));
      this.kit.disabled = !row;
    }
    clear() {
      this.request?.abort(); this.ready = false;
      this.section.classList.add('air-lift-fitment-pending');
      this.querySelector('[data-application]').textContent = '';
      this.status.textContent = '';
      this.native.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
      this.native.updateVariantContent();
    }
    async choose() {
      const id = this.kit.value;
      this.clear();
      const row = this.currentRow();
      if (!row || !row[3].includes(id)) return;
      const selector = [...this.native.optionSelectors][0];
      const input = [...selector.querySelectorAll('input')].find(input => input.value === this.data.kits[id]);
      if (!input) { this.status.textContent = this.dataset.error; return; }
      input.checked = true;
      this.request = new AbortController();
      this.status.textContent = this.dataset.loading;
      const url = this.native.constructVariantUrl(null, this.native.getSelectedOptionIds(), id);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Kit load failed');
        const sections = await response.json();
        if (!this.isConnected) return;
        const html = new DOMParser().parseFromString(sections[this.native.dataset.sectionId], 'text/html');
        const next = html.getElementById(this.section.id);
        const variant = JSON.parse(next.querySelector('variant-picker [type="application/json"]').textContent);
        if (String(variant.id) !== id) throw new Error('Kit mismatch');
        const picker = next.querySelector('air-lift-vehicle-picker');
        picker.dataset.yearSelected = this.year.value;
        picker.dataset.makeSelected = this.make.value;
        picker.dataset.modelSelected = this.model.value;
        const section = this.section;
        this.native.updateContent(section, next, false);
        section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = id; input.setAttribute('value', id); });
        setTimeout(() => { section.querySelector('variant-picker')?.announceChange(); section.querySelector('air-lift-vehicle-picker [data-kit]')?.focus(); }, 30);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) { this.clear(); this.status.textContent = this.dataset.error; this.kit.value = ''; }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["airllen-vehicle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('airllen-vehicle-picker')) {
  customElements.define('airllen-vehicle-picker', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.section = this.closest('.shopify-section');
        this.native = this.parentElement.querySelector('variant-picker');
        if (!this.native) return;
        this.data = JSON.parse(this.querySelector('[data-fitments]').textContent);
        this.data.fitments = this.data.fitments.flatMap(row => row[3].map(id => [row[0], row[1], row[3].length > 1 ? `${row[2]} — ${this.data.kits[id]}` : row[2], [id]]));
        ['year','make','model','kit'].forEach(key => { this[key] = this.querySelector(`[data-${key}]`); });
        this.status = this.querySelector('[data-status]');
        this.fill(this.year, [...new Set(this.data.fitments.map(r => r[0]))].sort((a,b) => b-a));
        const unspecifiedYear = [...this.year.options].find(o => o.value === '0'); if (unspecifiedYear) unspecifiedYear.textContent = this.dataset.unknownYear;
        this.year.value = this.dataset.yearSelected || '';
        this.populateMakes();
        this.make.value = this.dataset.makeSelected || '';
        this.populateModels();
        this.model.value = this.dataset.modelSelected || '';
        this.populateKits();
        this.kit.value = this.dataset.yearSelected ? this.dataset.selected : '';
        this.ready = Boolean(this.currentRow() && this.kit.value);
        if (!this.ready) this.clear();
        else this.querySelector('[data-application]').textContent = `${this.year.value} ${this.make.value} ${this.model.value} · ${this.kit.selectedOptions[0].textContent}`;
        this.section.classList.toggle('airllen-fitment-pending', !this.ready);
        const options = { signal: this.lifecycle.signal };
        this.year.addEventListener('change', () => { this.clear(); this.populateMakes(); this.populateModels(); this.populateKits(); }, options);
        this.make.addEventListener('change', () => { this.clear(); this.populateModels(); this.populateKits(); }, options);
        this.model.addEventListener('change', () => { this.clear(); this.populateKits(); const row = this.currentRow(); if (row) { this.kit.value = row[3][0]; this.choose(); } }, options);
        this.kit.addEventListener('change', () => this.choose(), options);
        this.section.addEventListener('submit', event => {
          if (!event.target.matches('.js-product-form')) return;
          const row = this.currentRow();
          if (!this.ready || !row || !row[3].includes(this.kit.value)) {
            event.preventDefault(); event.stopImmediatePropagation();
            (!this.year.value ? this.year : !this.make.value ? this.make : !this.model.value ? this.model : this.kit).focus();
            return;
          }
          event.target.querySelector('input[name="id"]').value = this.kit.value;
          const props = { 'Vehicle year': this.year.value === '0' ? this.dataset.unknownYear : this.year.value, 'Vehicle make': this.make.value, 'Vehicle model': this.model.value };
          Object.entries(props).forEach(([name,value]) => {
            let input = event.target.querySelector(`input[name="properties[${name}]"]`);
            if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; event.target.append(input); }
            input.value = value;
          });
        }, { capture: true, signal: this.lifecycle.signal });
        this.native.closest('.airllen-native-picker').hidden = true;
        this.hidden = false; if (this.ready) { const selectedId = this.kit.value; setTimeout(() => { if (!this.isConnected || !this.ready || this.kit.value !== selectedId) return; this.section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = selectedId; input.setAttribute('value', selectedId); }); }, 50); }
      });
    }
    disconnectedCallback() { this.lifecycle?.abort(); this.request?.abort(); }
    fill(select, values) {
      select.replaceChildren(new Option(this.dataset.placeholder, ''));
      values.forEach(value => select.add(new Option(String(value), String(value))));
    }
    currentRow() { return this.data.fitments.find(r => r[0] === Number(this.year.value) && r[1] === this.make.value && r[2] === this.model.value); }
    populateMakes() {
      this.fill(this.make, [...new Set(this.data.fitments.filter(r => r[0] === Number(this.year.value)).map(r => r[1]))].sort());
      this.make.disabled = !this.year.value;
    }
    populateModels() {
      this.fill(this.model, [...new Set(this.data.fitments.filter(r => r[0] === Number(this.year.value) && r[1] === this.make.value).map(r => r[2]))].sort());
      this.model.disabled = !this.make.value;
    }
    populateKits() {
      this.fill(this.kit, []);
      const row = this.currentRow();
      if (row) row[3].forEach(id => this.kit.add(new Option(this.data.kits[id], id)));
      this.kit.disabled = !row;
    }
    clear() {
      this.request?.abort(); this.ready = false;
      this.section.classList.add('airllen-fitment-pending');
      this.querySelector('[data-application]').textContent = '';
      this.status.textContent = '';
      this.native.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
      this.native.updateVariantContent();
    }
    async choose() {
      const id = this.kit.value;
      this.clear();
      const row = this.currentRow();
      if (!row || !row[3].includes(id)) return;
      const selector = [...this.native.optionSelectors][0];
      const input = [...selector.querySelectorAll('input')].find(input => input.value === this.data.kits[id]);
      if (!input) { this.status.textContent = this.dataset.error; return; }
      input.checked = true;
      this.request = new AbortController();
      this.status.textContent = this.dataset.loading;
      const url = this.native.constructVariantUrl(null, this.native.getSelectedOptionIds(), id);
      const preview = this.dataset.themeId;
      if (preview) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('_d2_selection', String(Date.now()));
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Kit load failed');
        const sections = await response.json();
        if (!this.isConnected) return;
        const html = new DOMParser().parseFromString(sections[this.native.dataset.sectionId], 'text/html');
        const next = html.getElementById(this.section.id);
        const variant = JSON.parse(next.querySelector('variant-picker [type="application/json"]').textContent);
        if (String(variant.id) !== id) throw new Error('Kit mismatch');
        const picker = next.querySelector('airllen-vehicle-picker');
        picker.dataset.yearSelected = this.year.value;
        picker.dataset.makeSelected = this.make.value;
        picker.dataset.modelSelected = this.model.value;
        this.section.replaceWith(next);
        const section = next;
        section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = id; input.setAttribute('value', id); });
        setTimeout(() => { const native = section.querySelector('variant-picker'); if (native) { native.variant = variant; native.updateVariantContent(); native.announceChange(); } section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = id; input.setAttribute('value', id); }); section.querySelector('airllen-vehicle-picker [data-model]')?.focus(); }, 30);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) { this.clear(); this.status.textContent = this.dataset.error; this.kit.value = ''; }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d2-racing-vehicle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('d2-racing-vehicle-picker')) {
  customElements.define('d2-racing-vehicle-picker', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.section = this.closest('.shopify-section');
        this.native = this.parentElement.querySelector('variant-picker');
        if (!this.native) return;
        const source = JSON.parse(this.querySelector('[data-fitments]').textContent); this.data = {kits:source.kits, fitments:source.ranges.flatMap(([from,to,make,model,kits]) => Array.from({length:to-from+1}, (_,i) => [from+i,source.makes[make],source.models[model],kits.map(k=>source.ids[k])]))};
        this.data.fitments = this.data.fitments.flatMap(row => row[3].map(id => [row[0], row[1], row[3].length > 1 ? `${row[2]} — ${this.data.kits[id]}` : row[2], [id]]));
        ['year','make','model','kit'].forEach(key => { this[key] = this.querySelector(`[data-${key}]`); });
        this.status = this.querySelector('[data-status]');
        this.fill(this.year, [...new Set(this.data.fitments.map(r => r[0]))].sort((a,b) => b-a));
        this.year.value = this.dataset.yearSelected || '';
        this.populateMakes();
        this.make.value = this.dataset.makeSelected || '';
        this.populateModels();
        this.model.value = this.dataset.modelSelected || '';
        this.populateKits();
        this.kit.value = this.dataset.yearSelected ? this.dataset.selected : '';
        this.ready = Boolean(this.currentRow() && this.kit.value);
        if (!this.ready) this.clear();
        else this.querySelector('[data-application]').textContent = `${this.year.value} ${this.make.value} ${this.model.value} · ${this.kit.selectedOptions[0].textContent}`;
        this.section.classList.toggle('d2-racing-fitment-pending', !this.ready);
        const options = { signal: this.lifecycle.signal };
        this.year.addEventListener('change', () => { this.clear(); this.populateMakes(); this.populateModels(); this.populateKits(); }, options);
        this.make.addEventListener('change', () => { this.clear(); this.populateModels(); this.populateKits(); }, options);
        this.model.addEventListener('change', () => { this.clear(); this.populateKits(); const row = this.currentRow(); if (row) { this.kit.value = row[3][0]; this.choose(); } }, options);
        this.kit.addEventListener('change', () => this.choose(), options);
        this.section.addEventListener('submit', event => {
          if (!event.target.matches('.js-product-form')) return;
          const row = this.currentRow();
          if (!this.ready || !row || !row[3].includes(this.kit.value)) {
            event.preventDefault(); event.stopImmediatePropagation();
            (!this.year.value ? this.year : !this.make.value ? this.make : !this.model.value ? this.model : this.kit).focus();
            return;
          }
          event.target.querySelector('input[name="id"]').value = this.kit.value;
          const props = { 'Vehicle year': this.year.value, 'Vehicle make': this.make.value, 'Vehicle model': this.model.value };
          Object.entries(props).forEach(([name,value]) => {
            let input = event.target.querySelector(`input[name="properties[${name}]"]`);
            if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; event.target.append(input); }
            input.value = value;
          });
        }, { capture: true, signal: this.lifecycle.signal });
        this.native.closest('.d2-racing-native-picker').hidden = true;
        this.hidden = false; if (this.ready) { const selectedId = this.kit.value; setTimeout(() => { if (!this.isConnected || !this.ready || this.kit.value !== selectedId) return; this.section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = selectedId; input.setAttribute('value', selectedId); }); }, 50); }
      });
    }
    disconnectedCallback() { this.lifecycle?.abort(); this.request?.abort(); }
    fill(select, values) {
      select.replaceChildren(new Option(this.dataset.placeholder, ''));
      values.forEach(value => select.add(new Option(String(value), String(value))));
    }
    currentRow() { return this.data.fitments.find(r => r[0] === Number(this.year.value) && r[1] === this.make.value && r[2] === this.model.value); }
    populateMakes() {
      this.fill(this.make, [...new Set(this.data.fitments.filter(r => r[0] === Number(this.year.value)).map(r => r[1]))].sort());
      this.make.disabled = !this.year.value;
    }
    populateModels() {
      this.fill(this.model, [...new Set(this.data.fitments.filter(r => r[0] === Number(this.year.value) && r[1] === this.make.value).map(r => r[2]))].sort());
      this.model.disabled = !this.make.value;
    }
    populateKits() {
      this.fill(this.kit, []);
      const row = this.currentRow();
      if (row) row[3].forEach(id => this.kit.add(new Option(this.data.kits[id], id)));
      this.kit.disabled = !row;
    }
    clear() {
      this.request?.abort(); this.ready = false;
      this.section.classList.add('d2-racing-fitment-pending');
      this.querySelector('[data-application]').textContent = '';
      this.status.textContent = '';
      this.native.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
      this.native.updateVariantContent();
    }
    async choose() {
      const id = this.kit.value;
      this.clear();
      const row = this.currentRow();
      if (!row || !row[3].includes(id)) return;
      const selector = [...this.native.optionSelectors][0];
      const input = [...selector.querySelectorAll('input')].find(input => input.value === this.data.kits[id]);
      if (!input) { this.status.textContent = this.dataset.error; return; }
      input.checked = true;
      this.request = new AbortController();
      this.status.textContent = this.dataset.loading;
      const url = this.native.constructVariantUrl(null, this.native.getSelectedOptionIds(), id);
      const preview = this.dataset.themeId;
      if (preview) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('_d2_selection', String(Date.now()));
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Kit load failed');
        const sections = await response.json();
        if (!this.isConnected) return;
        const html = new DOMParser().parseFromString(sections[this.native.dataset.sectionId], 'text/html');
        const next = html.getElementById(this.section.id);
        const variant = JSON.parse(next.querySelector('variant-picker [type="application/json"]').textContent);
        if (String(variant.id) !== id) throw new Error('Kit mismatch');
        const picker = next.querySelector('d2-racing-vehicle-picker');
        picker.dataset.yearSelected = this.year.value;
        picker.dataset.makeSelected = this.make.value;
        picker.dataset.modelSelected = this.model.value;
        this.section.replaceWith(next);
        const section = next;
        section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = id; input.setAttribute('value', id); });
        setTimeout(() => { const native = section.querySelector('variant-picker'); if (native) { native.variant = variant; native.updateVariantContent(); native.announceChange(); } section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = id; input.setAttribute('value', id); }); section.querySelector('d2-racing-vehicle-picker [data-model]')?.focus(); }, 30);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) { this.clear(); this.status.textContent = this.dataset.error; this.kit.value = ''; }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prazis-vehicle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('prazis-vehicle-picker')) {
  customElements.define('prazis-vehicle-picker', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.section = this.closest('.shopify-section');
        this.native = this.parentElement.querySelector('variant-picker');
        if (!this.native) return;
        this.rows = JSON.parse(this.querySelector('[data-fitments]').textContent);
        this.year = this.querySelector('[data-year]');
        this.make = this.querySelector('[data-make]');
        this.model = this.querySelector('[data-model]');
        this.status = this.querySelector('[data-status]');
        this.makePlaceholder = this.make.options[0].textContent;
        this.ranges = new Map(this.rows.map(row => [row[0], this.yearRange(row)]));
        const years = new Set();
        this.ranges.forEach(range => { if (range) for (let year = range[0]; year <= range[1]; year += 1) years.add(year); });
        [...years].sort((a, b) => b - a).forEach(year => this.year.add(new Option(String(year), String(year))));
        this.year.value = this.dataset.yearSelected || '';
        this.ready = Boolean(this.dataset.selected && this.year.value);
        this.section.classList.toggle('prazis-fitment-pending', !this.ready);
        this.populateMakes();
        const deepLinkId = new URLSearchParams(location.search).get('variant');
        const linked = this.rows.find(row => row[0] === this.dataset.selected && (this.dataset.yearSelected || row[0] === deepLinkId));
        const selected = linked && this.matchesYear(linked) ? linked : null;
        if (selected) {
          this.make.value = selected[1];
          this.populate(selected[0]);
          const mounts = this.querySelector('[data-mounts]');
          mounts.querySelector('span').textContent = selected[3];
          mounts.hidden = false;
          this.querySelector('[data-stock]').hidden = Number(this.querySelector('[data-stock]').dataset.quantity) < 1;
          this.querySelector('[data-application]').textContent = selected[2];
          this.querySelector('[data-application]').hidden = false;
        }
        if (!selected) {
          this.clearSelection();
          if (linked && !this.year.value) {
            this.pendingLink = linked;
            this.make.add(new Option(linked[1], linked[1]));
            this.make.value = linked[1];
            this.model.add(new Option(linked[2].split('|')[0].trim(), linked[0]));
            this.model.value = linked[0];
            this.status.textContent = this.dataset.confirmYear;
          }
        }
        const options = { signal: this.lifecycle.signal };
        this.year.addEventListener('change', () => {
          this.request?.abort();
          const linked = this.pendingLink;
          this.pendingLink = null;
          this.clearSelection();
          this.populateMakes();
          if (linked && this.matchesYear(linked)) {
            this.make.value = linked[1];
            this.populate(linked[0]);
            this.choose();
          } else {
            this.populate();
          }
        }, options);
        this.make.addEventListener('change', () => {
          this.request?.abort();
          this.clearSelection();
          this.populate();
        }, options);
        this.model.addEventListener('change', () => this.choose(), options);
        this.section.addEventListener('submit', event => {
          if (!event.target.matches('.js-product-form')) return;
          const row = this.rows.find(item => item[0] === this.model.value && item[1] === this.make.value && this.matchesYear(item));
          if (!this.ready || !row) {
            event.preventDefault();
            event.stopImmediatePropagation();
            (!this.year.value ? this.year : !this.make.value ? this.make : this.model).focus();
          } else {
            const input = event.target.querySelector('input[name="id"]');
            input.value = row[0];
          }
        }, { capture: true, signal: this.lifecycle.signal });
        this.native.closest('.prazis-native-picker').hidden = true;
        this.hidden = false;
      });
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.request?.abort();
    }
    yearRange(row) {
      const text = row[2].split('|')[1]?.trim();
      const match = text?.match(/^(\d{4}|\d{2})(?:[.\"]\d{1,2})?(?:~(UP|\d{4}|\d{2})(?:\.\d{1,2})?)?$/i);
      if (!match) return null;
      const expand = value => value.length === 4 ? Number(value) : Number(value) >= 50 ? 1900 + Number(value) : 2000 + Number(value);
      const start = expand(match[1]);
      const end = !match[2] ? start : match[2].toUpperCase() === 'UP' ? new Date().getFullYear() : expand(match[2]);
      return start <= end ? [start, end] : null;
    }
    matchesYear(row) {
      const range = this.ranges.get(row[0]);
      return Boolean(this.year.value && range && Number(this.year.value) >= range[0] && Number(this.year.value) <= range[1]);
    }
    populateMakes() {
      this.make.replaceChildren(new Option(this.makePlaceholder, ''));
      [...new Set(this.rows.filter(row => this.matchesYear(row)).map(row => row[1]))].sort().forEach(make => this.make.add(new Option(make, make)));
      this.make.disabled = !this.year.value;
    }
    populate(selected = '') {
      const rows = this.rows.filter(row => this.matchesYear(row) && row[1] === this.make.value);
      this.model.replaceChildren(new Option(this.dataset.placeholder, ''));
      rows.forEach(row => {
        const name = row[2].split('|')[0].trim();
        const duplicate = rows.some(other => other[0] !== row[0] && other[2].split('|')[0].trim() === name);
        this.model.add(new Option(duplicate ? `${name} · ${row[2].split('|').at(-1).trim()}` : name, row[0]));
      });
      this.model.value = selected;
      this.model.disabled = !this.make.value || rows.length === 0;
      this.status.textContent = this.make.value && !rows.length ? this.dataset.empty : '';
    }
    clearSelection() {
      this.ready = false;
      this.section.classList.add('prazis-fitment-pending');
      this.querySelector('[data-mounts]').hidden = true;
      this.querySelector('[data-stock]').hidden = true;
      this.querySelector('[data-application]').hidden = true;
      this.native.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
      this.native.updateVariantContent();
    }
    async choose() {
      this.request?.abort();
      const row = this.rows.find(item => item[0] === this.model.value && item[1] === this.make.value && this.matchesYear(item));
      this.clearSelection();
      if (!row) return;
      const selectors = [...this.native.optionSelectors];
      for (let i = 0; i < 3; i += 1) {
        const input = [...selectors[i].querySelectorAll('input')].find(item => item.value === row[i + 1]);
        if (!input) { this.status.textContent = this.dataset.error; return; }
        input.checked = true;
      }
      this.status.textContent = this.dataset.loading;
      this.request = new AbortController();
      const url = this.native.constructVariantUrl(null, this.native.getSelectedOptionIds(), row[0]);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Unable to load kit');
        const sections = await response.json();
        if (!this.isConnected) return;
        const html = new DOMParser().parseFromString(sections[this.native.dataset.sectionId], 'text/html');
        const newSection = html.getElementById(this.section.id);
        const variant = JSON.parse(newSection.querySelector('variant-picker [type="application/json"]').textContent);
        if (String(variant.id) !== row[0]) throw new Error('Fitment mismatch');
        const section = this.section;
        const native = this.native;
        newSection.querySelector('prazis-vehicle-picker').dataset.yearSelected = this.year.value;
        native.updateContent(section, newSection, false);
        section.querySelectorAll('.js-product-form input[name="id"]').forEach(input => { input.value = row[0]; input.setAttribute('value', row[0]); });
        setTimeout(() => {
          const picker = section.querySelector('variant-picker');
          picker.announceChange();
          section.querySelector('prazis-vehicle-picker [data-model]')?.focus();
        }, 30);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.clearSelection();
          this.status.textContent = this.dataset.error;
          this.model.value = '';
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["si-suspension-ack"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('si-suspension-ack')) {
  customElements.define('si-suspension-ack', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.form = this.closest('form');
      this.checkbox = this.querySelector('[type="checkbox"]');
      this.checkbox.checked = false;
      const signal = this.controller.signal;
      this.form.addEventListener('submit', event => {
        const invalid = [...this.querySelectorAll('[required]')].find(input => !input.checkValidity());
        const variant = this.form.querySelector('[name="id"]')?.value;
        if (invalid || !variant) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[role="alert"]').hidden = false;
          invalid?.reportValidity();
          return;
        }
        this.querySelector('[name="properties[_Suspension_accepted_at]"]').value = new Date().toISOString();
        this.querySelector('[name="properties[_Suspension_selected_variant]"]').value = variant;
        this.querySelector('[role="alert"]').hidden = true;
      }, { capture: true, signal });
      this.form.querySelector('[name="id"]')?.addEventListener('change', () => {
        this.checkbox.checked = false;
        this.querySelector('[name="properties[_Suspension_accepted_at]"]').value = '';
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
